import dayjs from 'dayjs';
import { CreneauType } from '../../app.constants';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { IPrecisionIntervention } from '../demande/precision-intervention';
import { FilePath } from '../dto/file-path.dto';
import { UUID } from '../uuid.model';
import { VacationIntervention } from '../vacation/vacation-intervention.model';
import { Consigne } from './consigne.model';
import { ContactReponseDTO } from './contact-reponse.dto';
import { ICreneauInter } from './creneau-inter.interface';
import { ISite } from './site.interface';
import { Site } from './site.model';
import { IPrecisionSite } from './precision-site.interface';
import { PrecisionSite } from './precision-site.model';

export class CreneauInterPonctuelle implements ICreneauInter {
  constructor(
    public readonly id: UUID,
    public readonly geolocEnabled: boolean,
    public readonly site: ISite | undefined,
    public readonly instant: dayjs.Dayjs,
    public readonly consignes: Consigne[] = [],
    public readonly materiel: string[],
    public readonly signatureEnabled = false,
    public champsPersonnalises: ChampCompteRendu[] = [],
    public readonly type = CreneauType.INTER_PONCTUELLE,
    public readonly debut: dayjs.Dayjs | undefined,
    public readonly fin: dayjs.Dayjs | undefined,
    public readonly acceptee: boolean,
    public readonly precisionSite: IPrecisionSite | undefined,
    public readonly origine: string,
    public readonly clientLibelle: string,
    public readonly numeroRappeler: string,
    public readonly prestationId: UUID,
    public readonly prestationLibelle: string,
    public readonly prestationReference: string,
    public readonly clientPhoto?: FilePath,
    public readonly vacation?: VacationIntervention,
    public readonly origineDetails?: string,
    public readonly compteRenduPreliminaireCloture?: boolean,
    public readonly clientAppele?: boolean,
    public readonly contactReponse?: ContactReponseDTO,
    public readonly precisions?: IPrecisionIntervention[]
  ) {}

  public static hydrate(creneau: CreneauInterPonctuelle): CreneauInterPonctuelle {
    return new CreneauInterPonctuelle(
      creneau.id,
      creneau.geolocEnabled,
      creneau.site ? Site.hydrate(creneau.site) : undefined,
      dayjs(creneau.instant),
      creneau.consignes ? creneau.consignes.map(Consigne.hydrate) : [],
      Object.assign([], creneau.materiel),
      creneau.signatureEnabled,
      creneau.champsPersonnalises ? creneau.champsPersonnalises.map(ChampCompteRendu.hydrate) : [],
      creneau.type,
      creneau.debut ? dayjs(creneau.debut) : undefined,
      creneau.fin ? dayjs(creneau.fin) : undefined,
      creneau.acceptee,
      creneau.precisionSite ? PrecisionSite.hydrate(creneau.precisionSite) : undefined,
      creneau.origine,
      creneau.clientLibelle,
      creneau.numeroRappeler,
      creneau.prestationId,
      creneau.prestationLibelle,
      creneau.prestationReference,
      creneau.clientPhoto ? FilePath.hydrate(creneau.clientPhoto) : undefined,
      creneau.vacation ? VacationIntervention.hydrate(creneau.vacation) : undefined,
      creneau.origineDetails,
      creneau.compteRenduPreliminaireCloture,
      creneau.clientAppele,
      creneau.contactReponse,
      creneau.precisions
    );
  }

  public getSiteLibelle(): string {
    return this.vacation?.site?.libelle ?? '';
  }
}
